import { useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../ui/dialog';
import { Label } from '../../ui/label';
import { Button } from '../../ui/button';
import { toast } from 'sonner';
import {CountryPhoneInput} from "@/components/common/CountryPhoneInput";


export function AddPhoneDialog({ open, onOpenChange, onSubmit }) {
    const [phone, setPhone] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        const rawPhone = phone;

        // Валидация номера телефона (например, 375 и 9 цифр после)
        const phoneRegex = /^375\d{9}$/;
        if (!phoneRegex.test(rawPhone)) {
            toast.error("Пожалуйста, введите корректный номер телефона (например, +375 (XX) XXX-XX-XX)");
            return;
        }

        if (phone.trim()) {
            onSubmit(phone);
            setPhone('');
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md bg-olive-50 border">
                <DialogHeader>
                    <DialogTitle className="text-olive-900">Добавить номер телефона</DialogTitle>
                    <DialogDescription className="text-olive-800">
                        Введите ваш номер телефона для верификации
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={handleSubmit}>
                    <div className="grid gap-4 py-4">
                        <div className="grid gap-2">
                            <Label htmlFor="phone" className="text-olive-900">
                                Номер телефона
                            </Label>
                            <CountryPhoneInput
                                placeholder="375 (xx) xxx-xx-xx"
                                inputStyle={{ width: "100%" }}
                                required
                                value={phone} // Отображаем отформатированный номер из состояния
                                onChange={e => {
                                    setPhone(e); // Обновляем состояние "чистыми" цифрами
                                }}
                            />
                        </div>
                    </div>
                    <DialogFooter className="flex gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                        >
                            Отмена
                        </Button>
                        <Button
                            type="submit"
                        >
                            Продолжить
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
